import React from 'react';
import Modal from 'components/ModalPopup';
import { Text } from '@mantine/core';

interface ModalNoteAssessmentProps {
  opened: boolean;
  onClose: () => void;
  theText?: string;
}

const ModalNoteAssessment: React.FC<ModalNoteAssessmentProps> = ({ opened, onClose, theText }) => {
  return (
    <Modal opened={opened} close={onClose} withCloseButton size='full' title='Assessment Notes'>
      {theText && (
        <Text style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{theText}</Text>
      )}
    </Modal>
  );
};

export default ModalNoteAssessment;
